"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _utils = require("../utils");
var _Flex = _interopRequireDefault(require("./Flex"));
var _core = require("@emotion/core");
var _excluded = ["children", "container"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var ColBase = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$container = _ref.container,
    Container = _ref$container === void 0 ? _Flex.default : _ref$container,
    outerProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _core.jsx)(Container, (0, _extends2.default)({
    flexDirection: "column",
    ref: ref
  }, outerProps), children);
}); // Force TS to accept .withComponent

var ColStyled = ColBase;
ColStyled.withComponent = function (tag) {
  var Container = _Flex.default.withComponent(tag, {
    target: "ebn2p5z0"
  });
  return /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
    return (0, _core.jsx)(ColBase, (0, _extends2.default)({}, props, {
      ref: ref,
      container: Container
    }));
  });
};
var ColWithDocs = (0, _stencilReactDesc.describe)(ColStyled).description('Flex defaulting to column direction, for implementing vertical layouts.');
ColWithDocs.propTypes = _objectSpread({}, (0, _utils.omit)(_Flex.default.describedPropTypes, ['flexDirection']));
var Col = (0, _utils.withTestAttributes)({
  component: 'StencilReactCol'
})(ColWithDocs);
Col.displayName = 'Col';
var _default = Col;
exports.default = _default;